// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2IXqZ","name":"Header_name__3OAse","birthday":"Header_birthday__fH1kn","skeleton":"Header_skeleton__1OC1K"};